import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import TitleText, { TitleTextSize } from "../../../components/TitleText";
import Paragraph from "../../../components/Paragraph";
import { JokerButton } from "material-ui-jokerpro";
import { useTranslation } from "react-i18next";
import StylePack from "../../../util/StylePack.js";
import styles from "./SignUp.module.css";
import PhoneInput from "react-phone-input-2";
import "./SignUp.css";
import clsx from "clsx";
import InputBox, {
  InputBoxRoundedCornors,
  InputBoxState,
} from "../../../components/InputBox";
import AssetsPack from "../../../util/AssetsPack.js";
import TwoColLayout from "../../Templates/TwoColLayout";
import MainTemplate from "../../Templates/MainTemplate";
import { useAppDispatch } from "../../../store/hooks";
import {
  checkEmailExist,
  sendVerifyCode,
} from "../../../store/on-boarding-slice";
import { SendVerifyCodeAction } from "../../../api/models/SendVerifyCodeAction";
import { ContactType } from "../../../api/models/ContactType";
import { showConsoleMessage } from "../../../util/ConsoleMessage";
import { isValidEmail, isValidMobileNumber } from "../../../util/Validator";
import ImageComponent from "../../../components/ImageComponent";

const SignUp = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [emailState, setEmailState] = useState<InputBoxState>(
    InputBoxState.default
  );
  const [phoneState, setPhoneState] = useState<InputBoxState>(
    InputBoxState.default
  );
  const [errorEmail, setErrorEmail] = useState<string | undefined>();
  const [errorPhone, setErrorPhone] = useState<string | undefined>(undefined);
  const [phone, setPhone] = useState("");
  const isFormValid =
    emailState === InputBoxState.success &&
    phoneState === InputBoxState.success &&
    !errorPhone;

  const dispatch = useAppDispatch();

  const handleContinue = async (e: React.FormEvent) => {
    e.preventDefault();
    if (
      emailState != InputBoxState.error &&
      phoneState != InputBoxState.error
    ) {
      try {
        await dispatch(checkEmailExist(email));
        await dispatch(
          sendVerifyCode(
            SendVerifyCodeAction.emailVerification,
            ContactType.email,
            email
          )
        );

        await dispatch(
          sendVerifyCode(SendVerifyCodeAction.register, ContactType.sms, phone)
        );
        navigate("/verify_email");
      } catch (error: any) {
        showConsoleMessage(" Error:", JSON.stringify(error, null, 2));
        if (error.type == ContactType.sms) {
          setErrorPhone(error.errorObj.data.error);
          setPhoneState(InputBoxState.error);
        } else {
          if (error.errorObj) {
            setErrorEmail(error.errorObj.data.error);
            setEmailState(InputBoxState.error);
          } else {
            setErrorEmail(error.data.error);
            setEmailState(InputBoxState.error);
          }
        }
        return;
      }
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (value.length === 0) {
      setEmailState(InputBoxState.default);
      setErrorEmail(undefined);
    } else if (isValidEmail(value)) {
      setEmailState(InputBoxState.success);
      setErrorEmail(undefined);
    } else {
      setEmailState(InputBoxState.error);
      setErrorEmail(t("error.invalid_login.invalid_email_format"));
    }
  };

  const handlePhoneChange = (value: string) => {
    setPhone(value);
    if (!value) {
      setPhoneState(InputBoxState.default);
      setErrorPhone(undefined);
    } else if (isValidMobileNumber(value)) {
      setPhoneState(InputBoxState.success);
      setErrorPhone(undefined);
    } else {
      setPhoneState(InputBoxState.error);
      setErrorPhone(t("error.invalid_login.invalid_mobile_number"));
    }
  };

  const navigate = useNavigate();

  const leftContent = (
    <div className={styles["form-section"]}>
      <div className={styles["text-wrapper"]}>
        <TitleText size={TitleTextSize.heading3}>
          {t("signup_page.title")}
        </TitleText>
        <Paragraph>{t("signup_page.subtitle")}</Paragraph>
      </div>
      <div className={styles["input-container"]}>
        <InputBox
          state={emailState}
          roundedCornors={InputBoxRoundedCornors.all}
          type="email"
          placeholder={t("signup_page.email_placeholder")}
          value={email}
          onChange={handleEmailChange}
          errorMessage={errorEmail}
        />
        <div
          className={clsx(
            "react-tel-input",
            phoneState === InputBoxState.success && "success",
            phoneState === InputBoxState.error && "error"
          )}
        >
          <PhoneInput
            country={"au"}
            value={phone}
            onChange={handlePhoneChange}
          />
          {phoneState === InputBoxState.success && (
            <ImageComponent
              src={AssetsPack.icons.ICON_CHECK_GREEN_CIRCLE.default}
              className={clsx("icon")}
            />
          )}
        </div>
        {errorPhone && (
          <span className={clsx("error-message")}>{errorPhone}</span>
        )}
      </div>
      <div className={styles["button-wrapper"]}>
        <JokerButton
          text={t("signup_page.continue")}
          icon={AssetsPack.icons.ICON_GO.default}
          onClick={handleContinue}
          disabled={!isFormValid}
        />
      </div>
    </div>
  );

  const rightContent = null;
  const body = (
    <TwoColLayout leftContent={leftContent} rightContent={rightContent} />
  );
  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      hasOverlayFooter
      backgroundStyle={StylePack.BACKGROUND_LOGIN_STYLE}
    />
  );
};

export default SignUp;
